import * as $ from "jquery";
import * as GSAP from 'gsap';
import 'bootstrap';
import QuestionElement from "./pages/QuestionElement";

export module App {

    $(function () {
        createQuestion();
        createCTA();
        $(window).on("resize", windowResizeHandler);
        windowResizeHandler(null);

        $(window).on("scroll", windowScrollHandler);
        windowScrollHandler(null);
    });

    function windowResizeHandler(e: JQuery.Event) {
        resizeKV();
    }

    function resizeKV() {
        const kvSection = $('.kv-s1');
        const kvTrigger = $('.kv_trigger');
        const graphicWrapper = kvSection.find('.graphic_wrapper-fit');
        const graphicGuide = kvSection.find('.kv_graphic-back');
        if (window.innerHeight >= graphicGuide.height()) {
            graphicWrapper.height(graphicGuide.height());
            kvTrigger.height(graphicGuide.height());
        } else {
            graphicWrapper.height(window.innerHeight);
            kvTrigger.height(window.innerHeight);
        }
    }

    function windowScrollHandler(e: JQuery.Event) {
        const scrollTop = $('html').scrollTop() || $('body').scrollTop();
        const ctaSection = $('.cta');
        const ctaButton = $('.cta_button');
        if ((ctaSection.offset().top - scrollTop - window.innerHeight) <= 0) {
            ctaButton.removeClass('active');
        } else {
            ctaButton.addClass('active');
        }
    }


    function createCTA() {
        const ctaSection = $('section.cta');
        const ctaButton = $('.triggerButton');
        ctaButton.on('click tap', (e) => {
            e.preventDefault();
            scrollToElement($('section.question'));
        });

       /* const globalCtaButton = $('.cta_button');
        globalCtaButton.on('click tap', (e) => {
            e.preventDefault();
            scrollToElement($('section.question'));
        });*/
    }


    let qaElement: QuestionElement;

    function createQuestion() {
        qaElement = new QuestionElement($('section.question'));
    }

    function scrollToElement(target: JQuery, fixH: number = 0) {
        let offsetTop: number = target.offset().top;
        let targetTop: number = offsetTop - fixH;

        $(window).animate({
            scrollTop: targetTop
        }, 1000);
        $("body,html").animate({
            scrollTop: targetTop
        }, 1000);
    }


    export function openModal() {
        $('#mapModal').modal('show');
    }

    export function closeModal() {
        $('#mapModal').modal('hide');
    }

    export function gotoLineForm() {
        qaElement.changeQuestion(1);
    }
}
(<any>window).ShiseidoApp = App;